// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Zachary Thomas
//
// Last Modified: 2025-11-04
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Attempt to load initial state from local storage.
let initialToken = null;
const localStorageToken = localStorage.getItem("reduxRefreshToken");
if (localStorageToken !== "") {
  initialToken = localStorageToken;
}

const initialState: string | null = initialToken;

// A Redux slice for the refresh token that is passed to the backend.
const refreshTokenSlice = createSlice({
  name: "refreshToken",
  initialState,
  reducers: {
    setRefreshToken: (state, action: PayloadAction<string | null>) => {
      localStorage.setItem("reduxRefreshToken", action.payload ?? "");
      return action.payload;
    },
  },
});

export const { setRefreshToken } = refreshTokenSlice.actions;
export default refreshTokenSlice.reducer;
